import PropTypes from 'prop-types';
import { Outlet } from 'react-router-dom';

import Sidebar from '../components/Sidebar';

const MainContainer = ({ withSidebar }) => (
  <main className="bg-[#FAFAFA]">
    {withSidebar
      ? (
        <section className="max-w-9xl mx-auto flex relative custom-min-height">
          <div className="relative hidden md:block md:w-1/4">
            <Sidebar />
          </div>
          <div className="pb-24 md:pb-6 p-6 xl:p-[40px] w-full md:w-3/4">
            <Outlet />
          </div>
        </section>
      ) : (
        <section className="max-w-9xl mx-auto md:grid md:grid-cols-[4fr_3fr] place-content-center">
          <Outlet />
        </section>
      )}

  </main>
);

MainContainer.propTypes = {
  withSidebar: PropTypes.bool,
};

MainContainer.defaultProps = {
  withSidebar: false,
};

export default MainContainer;
